import {Component, Input} from '@angular/core';
import {SvgIcon} from '@valg-shared/utils/svg-icon';
import {ExportOptions} from './export-options';
import {ExportService} from '@valg-shared/services/export-service/export.service';
import {HeaderMetatada} from '@valg-shared/services/export-service/header-metadata';

@Component({
  selector: 'valg-data-export',
  templateUrl: './data-export.component.html',
  styleUrls: [ './data-export.component.scss' ]
})
export class DataExportComponent<T> implements ExportOptions<T> {

  public SvgIcon = SvgIcon;

  @Input()
  data: T[];

  @Input()
  canExportHeadersOnly = false;

  @Input()
  filename?: string = undefined;

  @Input()
  exportFunction?: () => Promise<T[]> | T[]

  @Input()
  headers: HeaderMetatada[];

  @Input()
  buttonText?: string

  @Input()
  toPdf?: boolean = false;

  @Input()
  exportButtonIcon?: string;

  constructor(
    private readonly exportService: ExportService) {
    this.data = [];
    this.headers = [];
  }

  async onClick() {
    if(this.toPdf){
      if (this.exportFunction != undefined) {
        await this.exportFunction()
      }
    }
    else{
      if(!this.filename)
      {
        this.filename = "export.csv";
      }
      if (this.exportFunction != undefined) {
        this.data = await this.exportFunction() 
        this.exportService.Export(this.filename, this.data, this.headers, this.canExportHeadersOnly)
      } else {
        this.exportService.Export(this.filename, this.data, this.headers, this.canExportHeadersOnly)
      }    
    }
  }
}
